import { render, staticRenderFns } from "./welcome-numbering-plan.vue?vue&type=template&id=5c37a96a&scoped=true&"
import script from "./welcome-numbering-plan.vue?vue&type=script&lang=js&"
export * from "./welcome-numbering-plan.vue?vue&type=script&lang=js&"
import style0 from "./welcome-numbering-plan.vue?vue&type=style&index=0&id=5c37a96a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c37a96a",
  null
  
)

export default component.exports